import React, {FC, ReactNode, memo} from "react"
import { TableFooter, TableRow, TableHeaderCell, Button, Icon, Message, MessageHeader } from "semantic-ui-react"


interface CreatorTableFooterProps {
    addLabel: ReactNode
    addRow: () => void
    errorMessage: ReactNode
}

export const CreatorTableFooter: FC<CreatorTableFooterProps> = memo(({ addLabel, addRow, errorMessage }) => {
    return (
        <TableFooter fullWidth className="table-footer">
            <TableRow>
                <TableHeaderCell style={{ width: "5.35em" }}/>
                <TableHeaderCell>
                    <Button primary icon floated="left" labelPosition="left" size="small" onClick={addRow}><Icon name="user"/>{addLabel}</Button>
                    {errorMessage &&
                        <Message negative className="creator-footer-message">
                            <MessageHeader>{errorMessage}</MessageHeader>
                        </Message>
                    }
                </TableHeaderCell>
            </TableRow>
        </TableFooter>
    )
})